import { calculateEventTop, calculateEventHeight } from "@/lib/calendarPositioning";

interface BusyEvent {
  id: string;
  startTime: Date;
  endTime: Date;
  source?: string;
}

interface BusyBarsProps {
  events: BusyEvent[];
  dayStart?: number;
}

export function BusyBars({ events, dayStart = 0 }: BusyBarsProps) {
  return (
    <>
      {events
        .filter(ev => ev.source && ev.source !== "workdeck") // Personal calendar events only
        .map(ev => {
          const top = calculateEventTop(new Date(ev.startTime), dayStart);
          const height = calculateEventHeight(new Date(ev.startTime), new Date(ev.endTime));
          
          return (
            <div
              key={`busy-${ev.id}`}
              className="absolute left-0 right-0 bg-[var(--wd-blue-100)] opacity-40 rounded-sm pointer-events-none"
              style={{
                top: `${top}px`,
                height: `${height}px`,
              }}
              title={`Busy: ${ev.source || 'Personal calendar'}`}
              data-testid={`busy-bar-${ev.id}`}
            />
          );
        })}
    </>
  );
}
